import {
    Box,
    Container,
    Flex,
    Highlight,
    Skeleton,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import React from "react";

import FeaturedCarousel from "@/components/general/FeaturedCarousel";
import FeaturedPropCard from "@/components/general/FeaturedPropCard";

const FeaturedProperties = ({ data, session, savePropsFavorites, userFavorites }) => {
    const isGreaterThanLg = useBreakpointValue({ base: false, lg: true });
    const isGreaterThan2Xl = useBreakpointValue({ base: false, "2xl": true });

    const showSkeleton = () => {
        if (isGreaterThan2Xl) {
            return (
                <Flex
                    w="100%"
                    h="596px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="10"
                    bg="white"
                >
                    <Skeleton w="364px" h="100%" borderRadius="10px" />
                    <Skeleton w="364px" h="100%" borderRadius="10px" />
                    <Skeleton w="364px" h="100%" borderRadius="10px" />
                </Flex>
            );
        } else if (isGreaterThanLg) {
            return (
                <Flex
                    w="100%"
                    h="596px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="10"
                    bg="white"
                >
                    <Skeleton w="364px" h="100%" borderRadius="10px" />
                    <Skeleton w="364px" h="100%" borderRadius="10px" />
                </Flex>
            );
        }
        return (
            <Flex
                w="100%"
                h="596px"
                direction="row"
                alignItems="center"
                justifyContent="center"
                gap="2"
                bg="white"
            >
                <Skeleton w="364px" h="100%" borderRadius="10px" />
            </Flex>
        );
    };

    return (
        <Box
            bgColor="white"
            w="full"
            mx="auto"
            maxW="100%"
            paddingInline="0"
            position="relative"
            pb={10}
            pt={{ base: 10, md: 2 }}
        >
            <Box mb={10} align="center">
                <Text
                    as="h2"
                    fontSize={{ base: "md", md: "lg", lg: "2xl" }}
                    textAlign="center"
                    color="#002B49"
                >
                    <Highlight
                        query="Compra o invierte"
                        styles={{ fontWeight: "900", color: "#002B49" }}
                    >
                        Compra o invierte
                    </Highlight>
                </Text>
                <Text
                    fontSize={{ base: "sm", md: "md", lg: "xl" }}
                    color="#002B49"
                    textAlign="center"
                    mb="4"
                    fontWeight="400"
                    as="h3"
                >
                    <Highlight
                        query="#ElLugarParaTi"
                        styles={{ fontWeight: "500", color: "002B49" }}
                    >
                        En tu próxima propiedad en Grupo Guia
                    </Highlight>
                </Text>
            </Box>
            <Box mb={6}>
                <Container maxW="100%" width="100%">
                    {(!data || data.length === 0) && showSkeleton()}
                    {data && data.length > 0 && (
                        <FeaturedCarousel>
                            {data?.length > 0 &&
                                data.map((item, index) => (
                                    <FeaturedPropCard
                                        key={index}
                                        id={index}
                                        presale={item?.presale}
                                        sale={item?.sale}
                                        lease={item?.lease}
                                        title={item?.title}
                                        address={
                                            item?.location_props.street_name +
                                            " " +
                                            item?.location_props.exterior_number +
                                            (item?.location_props.city
                                                ? ", " + item?.location_props.city
                                                : "") +
                                            (item?.location_props.province
                                                ? ", " + item?.location_props.province
                                                : "") +
                                            (item?.location_props.country
                                                ? ", " + item?.location_props.country
                                                : "")
                                        }
                                        groundSize={
                                            item?.structure_props.ground_size ||
                                            item?.structure_props.construction_size
                                        }
                                        bedrooms={item?.structure_props.bedrooms}
                                        bathrooms={item?.structure_props.bathrooms}
                                        parkingLots={item?.structure_props.parking_lots}
                                        price={
                                            item?.sale
                                                ? item.sale
                                                : item?.lease
                                                  ? item.lease
                                                  : item?.presale
                                        }
                                        propertyType={item?.type}
                                        imageUrl={item?.photo}
                                        wiggotCode={item?.wiggot_code}
                                        session={session}
                                        property_id={item?.property_id}
                                        savePropsFavorites={savePropsFavorites}
                                        userFavorites={userFavorites}
                                    />
                                ))}
                        </FeaturedCarousel>
                    )}
                </Container>
            </Box>
        </Box>
    );
};

export default FeaturedProperties;
